// extracted by mini-css-extract-plugin
export default {"rowWrapper":"Feed_rowWrapper__DJHos"};